'use strict';

/**
 * Component for number
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 * @author     Augusto Campos-Leiva <augusto@campos-leiva.de>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/components/detail/field-number.hbs');

var NumberComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        value: function() {
            return this.getText();
        },
    },

    getText: function() {
        var field = this.getOption('field');

        return this.model.getTextValue(field.name);
    },

    hasValue: function() {
        return this.getText() ? true : false;
    },
});

module.exports = NumberComponent;